import { faFeather } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dialog, IconButton, PaperProps } from '@mui/material'
import { t } from "i18next"
import NewReviewCell from "../NewReviewCell"

const CreateButton = ({iconOnly, onClick, disabled = false}) => {
  if(iconOnly)
    return (<IconButton onClick={onClick} disabled={disabled} size="small">
            <FontAwesomeIcon icon={faFeather} />
        </IconButton>
    )
  else 
    return <Button onClick={onClick} variant="contained" color="success" size="small">{t("status.new", {context: 'f'})} {t("labels.review")}</Button>
}
/**
 * Used to remove the wrapping paper component, as the subcells already have this
 * @param props 
 * @returns 
 */
function DivComponent(props: PaperProps) {
  return (
      <div {...props}></div>
  );
}


const ReviewButton = ({ tank, className = "", iconOnly = false }) => {

  const [open, setOpen] = React.useState(false);

  return (
    <div className={className}>
      <CreateButton iconOnly={iconOnly} onClick={() => setOpen(!open)}/>

      <Dialog open={open} onClose={() => setOpen(!open)} 
        //https://stackoverflow.com/a/60436717/1437016 only could prevents bubbling, but stopPropagation ensures it
        onClick={(e)=>{e.stopPropagation()}} 
        PaperComponent={DivComponent}>
        <NewReviewCell idTank={tank.id}/>
      </Dialog>
    </div>
  )
}

export default ReviewButton